import type { Dict } from '@/typings'
import option2Map from '@/utils/options2Map'

/**
 * 仓库的默认有效期时间，不展示
 */
export const STOCK_DEFAULT_EXPIRE_TIMESTAMP = 32503564800000
export const STOCK_DEFAULT_EXPIRE = '2999-12-31'

export const MAX_SAFETY_STOCK = 1e6 - 1
export const MAX_SAFETY_STOCK_PERCENTAGE = 99

/** 触发动作 */
export const STOCK_ASYNC_ACTIONS_OPTIONS: Dict = [
  // 采购入库
  {
    label: 'warehousing.detail.purchase',
    value: 'purchase',
  },
  // 退货入库
  {
    label: 'warehousing.detail.refund',
    value: 'return',
  },
  // 库存调整
  {
    label: 'stock.async.stockAdjust',
    value: 'stockAdjust',
  },
  // 手动覆盖
  {
    label: 'stock.async.manualReplace',
    value: 'manualReplace',
  },
  // 定时规则覆盖
  {
    label: 'stock.async.autoCover',
    value: 'timedReplace',
  },
  // 组合商品库存转换
  {
    label: 'stock.async.groupStockConversion',
    value: 'skuGroupStockConvert',
  },
]

/** 触发动作 */
export const STOCK_ASYNC_ACTIONS_MAP = option2Map(STOCK_ASYNC_ACTIONS_OPTIONS)

/** 分配模式 */
export const STOCK_ALLOCATE_MODE_OPT: Dict<{ label: string; value: 'exclusive' | 'shared' }> = [
  {
    label: 'stock.async.distribution.exclusive',
    value: 'exclusive',
  },
  {
    label: 'stock.async.distribution.shared',
    value: 'shared',
  },
]

export enum STOCK_ALLOCATE_MODE {
  /** 独享模式 */
  EXCLUSIVE = 'exclusive',
  /** 共享模式 */
  SHARED = 'shared',
}
/** 分配模式 */
export const STOCK_ALLOCATE_MODE_MAP = option2Map(STOCK_ALLOCATE_MODE_OPT)

/** 类型 */
export const STOCK_ASYNC_TYPES_OPTIONS: Dict = [
  {
    label: 'common.add', // 新增
    value: 1,
  },
  {
    label: 'common.replace', // 覆盖
    value: 2,
  },
]

/** 类型 */
export const STOCK_ASYNC_TYPES_MAP = option2Map(STOCK_ASYNC_TYPES_OPTIONS)

/** 同步频率 */
export enum FREQUENCY_TYPE_ENUM {
  // 增量同步
  'stock_increment_sync' = 'stock_increment_sync',
  //  定时同步
  'timed_full_coverage' = 'timed_full_coverage',
}

export const FREQUENCY_TYPE = [
  {
    value: 'stock_increment_sync',
    label: 'stock.async.frequency.stock_increment_sync',
  },
  {
    value: 'timed_full_coverage',
    label: 'stock.async.frequency.timed_full_coverage',
  },
]

export const FREQUENCY_TYPE_MAP = option2Map(FREQUENCY_TYPE)

/** 同步时间 */

export const SYNC_TIME_RANGE = [
  {
    label: '00:00 ~ 06:00',
    value: '00:00~06:00',
  },
  {
    label: '06:00 ~ 12:00',
    value: '06:00~12:00',
  },
  {
    label: '12:00 ~ 18:00',
    value: '12:00~18:00',
  },
  {
    label: '18:00 ~ 24:00',
    value: '18:00~24:00',
  },
]
